import React, { ChangeEvent, useEffect, useState } from 'react';

import { EmbedComponentProps } from './EmbedComponent';
import TextField from '@mui/material/TextField';
import { cloneDeep } from 'lodash';
import { useLessonEditContext } from '../../../content/models/LessonEditContext';

export function EmbedEdit(props: EmbedComponentProps) {
  const { handleSettingsChange } = useLessonEditContext();

  const [value, setValue] = useState(props.component.content.embedCode);

  useEffect(() => {
    setValue(props.component.content.embedCode);
  }, [props.component.content.embedCode]);

  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    setValue(event.target.value);
  }

  function handleBlur() {
    const copy = cloneDeep(props.component);
    copy.content.embedCode = value;
    handleSettingsChange(copy);
  }

  return (
    <>
      <TextField
        multiline
        variant="outlined"
        InputProps={{
          sx: { fontSize: '17px' }
        }}
        sx={{ width: '100%' }}
        minRows={4}
        value={value}
        placeholder="Embed code..."
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </>
  );
}
